"use client";
import { MoveRight, ChevronDown } from "lucide-react";
import { useState } from "react";
import { useRouter } from "next/navigation";

type NavItem = {
  label: string;
  links: { label: string; href: string }[];
};

type Props = {
  navItems: NavItem[];
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

export default function MobileMenu({ navItems, setIsOpen }: Props) {
  const [activeDropdown, setActiveDropdown] = useState<number | null>(null);
  const router = useRouter();

  const handleLinkClick = (href: string) => {
    router.push(href);
    setActiveDropdown(null);
    setIsOpen(false);
  };

  const handleToggle = (index: number) => {
    setActiveDropdown((prev) => (prev === index ? null : index));
  };

  return (
    <ul className="grid grid-cols-1 sm:grid-cols-2 gap-2 items-start">
      {navItems.map((item, index) => (
        <li key={index} className="relative">
          <button
            type="button"
            onClick={() => handleToggle(index)}
            className={`w-full text-left flex items-center justify-between text-base font-semibold gap-2 px-5 py-4 rounded-xl transition-all duration-200 cursor-pointer ${
              activeDropdown === index
                ? "bg-[var(--acento-nav)] text-[var(--fondoGeneral-secciones)] shadow-lg"
                : "bg-white/5 text-white border border-white/15 hover:bg-white/10"
            }`}
          >
            <span>{item.label}</span>
            <ChevronDown
              size={18}
              className={`transition-transform duration-300 ${
                activeDropdown === index ? "rotate-180" : ""
              }`}
            />
          </button>

          {activeDropdown === index && (
            <div className="mt-2 bg-white/5 rounded-xl overflow-hidden border border-white/10 animate-slide-down">
              {item.links.length > 0 ? (
                <div className="py-2">
                  {item.links.map((link, i) => (
                    <button
                      key={i}
                      onClick={() => handleLinkClick(link.href)}
                      className="flex w-full items-center justify-between px-5 py-3 text-sm text-white/80 hover:bg-white/10 hover:text-white transition-all duration-200 cursor-pointer group"
                    >
                      <span className="font-medium">{link.label}</span>
                      <MoveRight className="w-4 h-4 text-[var(--acento-nav)] opacity-70 group-hover:opacity-100 group-hover:translate-x-1 transition-all duration-200" />
                    </button>
                  ))}
                </div>
              ) : (
                <p className="text-sm text-white/40 px-5 py-4 italic">
                  Próximamente
                </p>
              )}
            </div>
          )}
        </li>
      ))}
    </ul>
  );
}
